module.exports = __webpack_public_path__ + "img/uparrow.cef2c02d.svg";